<template>
  <div id="app" :style="appresize">
    <login-popup v-model="showLoginPopup"></login-popup>
    <add-game-popup
      ref="playingGamePopup"
      @getGameSheQu="handlePlayingGameSelected"
      @closed="handlePlayingGamePopupClosed"
    ></add-game-popup>
    <!-- <button style="margin-top: 100px;" @click="func">交互测试</button> -->
    <layout></layout>
  </div>
</template>
<script>
import { isMobile, debounce } from "@/utils/index";
import { wechatSignData } from "@/api/init";
import LoginPopup from '@/components/login-popup/login-popup.vue'
import AddGamePopup from '@/components/add-game-popup/add-game-popup.vue'
import { mapState, mapActions, mapGetters } from "vuex";
import DowBox from './pages/sdkpage/dowBox.vue';
import Layout from './components/layout/layout.vue';
import tokenUtil from '@/utils/token'
import { onPlusReady } from "@/utils/plus.js"
export default {
  components: {
    LoginPopup,
    AddGamePopup,
    DowBox,
    Layout
  },
  data() {
    return {
      appresize: {
        maxWidth: "523px",
        margin: "0 auto",
      },
      cachedViews: "",
      hasBindAppCloseLogout: false,
      hasBindWebviewLifecycleLogout: false,
      hasLoggedOutByWebviewClose: false,
      webviewCloseHandler: null
    };
  },

  computed: {
    ...mapGetters(['logged']),
    ...mapState({
      loginpop: state => state.popup.loginpop,
      playingGamePopup: state => state.popup.playingGamePopup
    }),
    showLoginPopup: {
      get() {
        return this.loginpop
      },
      set(val) {
        this.$store.commit('popup/setloginpop', val)
      }
    }
  },
  watch: {
    'playingGamePopup.show'(show) {
      if (show) {
        this.$nextTick(() => {
          this.openPlayingGamePopupRef()
        })
      }
    }
  },
  created() {
    // if(localStorage.getItem('ajaxActiveBaseURL')){
    //   localStorage.removeItem('ajaxActiveBaseURL')
    //   location.reload()
    // }
    window.addEventListener('message', (event) => {
      this.data = event.data;
      this.getUniMessage(event.data);
    })
    if (this.$store.getters.logged) {
      this.$store.commit('setNoticeTimer', true);
    }
    this.$store.dispatch('init');
    this.cachedViews = this.$router.options.routes
      .filter(route => route.meta?.keepAlive)
      .map(route => route.name)
      .filter(Boolean)
      .join(',')
  },

  mounted() {
    this.$root.$on('open-playing-game-popup', this.openPlayingGamePopupRef)
    this.init();
    window.addEventListener('orientationchange', this.handleOrientationChange);

    window.onload = () => {
      const advertisingId = this.$route.query.advertisingId;
      if (advertisingId) {
        localStorage.setItem('advertisingId', advertisingId)
      }
      // uni.postMessage({ data: { action: 'uniToh5DeviceInfo', params: {} } })
    }

    onPlusReady(() => {
      try {
        this.logout()
        const height = plus.navigator.getStatusbarHeight()
        this.$store.commit('setStatusBarHeight', height)
        uni.postMessage({
          data: {
            action: 'uniToh5SetAuth',
            params: {}
          }
        })
        uni.postMessage({ data: { action: 'h5loadSuccess', params: {} } })
      } catch (error) {
        console.log(error);
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('open-playing-game-popup', this.openPlayingGamePopupRef)
    window.removeEventListener('orientationchange', this.handleOrientationChange) 
  },
  methods: {
    ...mapActions(["logout"]),
    openPlayingGamePopupRef() {
      if (this.$refs.playingGamePopup && this.$refs.playingGamePopup.open) {
        this.$refs.playingGamePopup.open()
      }
    },
    handlePlayingGameSelected() {
      const shouldNavigateToCommunity = this.playingGamePopup.navigateToCommunity
      this.$store.commit('popup/setPlayingGamePopup', { show: false })
      if (shouldNavigateToCommunity && this.$route.path !== '/pages/community/community') {
        this.$router.push('/pages/community/community')
      }
    },
    handlePlayingGamePopupClosed() {
      if (this.playingGamePopup && this.playingGamePopup.show) {
        this.$store.commit('popup/setPlayingGamePopup', { show: false })
      }
    },
    func() {
      try {
        uni.postMessage({
          data: {
            action: 'share',
            params: {
              title: '分享标题',
              summary: '分享内容',
              url: 'https://www.baidu.com',
              image: 'https://www.baidu.com/img/flexible/logo/pc/result.png'
            }
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    getUniMessage(data) {
      switch (data.action) {
        case 'uniToh5SetAuth':
          if (data.data.token) {
            tokenUtil.save(data.data.token)
            this.$store.dispatch('getUserInfo').then(() => {
              window.dispatchEvent(new CustomEvent('h5-token-ready'))
            })
          }
          break;
        case 'onShow':
          // this.$toast('onShow');
          break;
        case 'onHide':
          // this.$toast('onHide');
          break;
        case 'onUnload':
          // localStorage.setItem('firstLoad', '')
          this.logout()
          break;
        case 'uniToh5DeviceInfo':
          console.log('deviceInfo', data);
          this.$store.commit('setDeviceInfo', data.data);
          break;
        case 'uniToH5LoadData':
          this.$store.commit('setIsApp', data.data.isApp);
          this.$store.commit('setIsFullScreen', data.data.isFullScreen);
          this.$store.commit('setIsEmbedded', data.data.isEmbedded); // 是否内嵌webview
          console.log('uniToH5LoadData', JSON.stringify(data));
          
          break
        default:
          break;
      }
    },
    handleOrientationChange() {
      window.location.reload();
    },
    appstyle() {
      let arr = ['cloudPhoneGame']
      let find = arr.findIndex(item => item == this.$route.name)
      if (find > -1) {
        this.appresize = {};
        this.appresize.width = "100%";
        return
      }
      if (isMobile()) {
        this.appresize = {};
        this.appresize.width = "100%";
      } else {
        this.appresize = {
          maxWidth: "523px",
          margin: "0 auto",
        };
      }
    },
    init() {
      const cancalDebounce = debounce(this.appstyle, 0);
      window.addEventListener("resize", cancalDebounce);
    },
  },
  watch: {
    '$store.getters.logged': {
      handler(val) {
        if (val) {
          console.log('tokenUtil.read()', tokenUtil.read());
          uni.postMessage({
            data: {
              action: 'h5ToUniSetAuth',
              params: {
                token: tokenUtil.read()
              }
            }
          })
          this.$store.commit('setNoticeTimer', true);
        } else {
          this.$store.commit('setNoticeTimer', false);
        }
      },
    },
    '$store.getters.isFullScreen': {
      handler(val) {
        if(!val) {
          this.$store.commit('setStatusBarHeight', 0)
        }
      }
    }
  },
};
</script>
<style lang="scss">
::-webkit-scrollbar {
  display: none;
}

@media screen and (min-width: 523px) {
  ::-webkit-scrollbar {
    width: 0.15rem;
    height: 0.15rem;
    background-color: #f5f5f5;
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #ffdb89;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }
}

body {
  background-color: #f8f8f8;
  font-size: 0.7rem !important;
}

#app {
  max-width: 523px;
  margin: 0 auto;
}

/* 限制固定定位元素的最大宽度 */
.fixed-width-container {
  position: fixed;
  max-width: 523px;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
}

/* 为所有固定定位的元素添加最大宽度限制 */
[class*="fixed"],
.top-nav,
.backimg,
.navbar,
.tabbar {
  position: fixed;
  max-width: 523px !important;
  width: 100%;
  left: 50% !important;
  transform: translateX(-50%);
}

* {
  margin: 0;
  padding: 0;
}

body,
html {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  word-break: break-all;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

li {
  list-style-type: none;
}
</style>
